export default {
  id: null,
  funcionarioId: null,
  funcionarioSubstitutoId: null,
  funcionariosPermissaoId: [],
  groupId: [],
  pessoaId: null,
  username: null,
  currentPassword: null,
  password: null,
  email: null,
  inative: false,
  administrador: false,
  permissoes: [],
  acessos: [],
  mfaActive: null,
  ldapAuthentication: null,
  externalUser: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configurations/accountmodel.js